module.exports = __webpack_public_path__ + "static/media/specs-on.25f790fa.svg";